import React, { Component } from 'react';

// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { createForm, formShape } from 'rc-form';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';

// @ts-ignore ts-migrate(7016) FIXME: Try `npm install @types/autosuggest-highlight` if ... Remove this comment to see the full error message
import match from 'autosuggest-highlight/match';

// @ts-ignore ts-migrate(7016) FIXME: Try `npm install @types/autosuggest-highlight` if ... Remove this comment to see the full error message
import parse from 'autosuggest-highlight/parse';
import Location from '@solvhealth/types/interfaces/Location';
import { fontFamily, fontSize } from '../../constants/text';
import Button, { ButtonVariations } from '../SolvPatternLibrary/Button';
import TextField from '../SolvPatternLibrary/TextField';
import SelectTextField from '../SolvPatternLibrary/SelectTextField';
import history from '../../core/history';
import { isEmpty } from '../../core/util/empty';
import {
  INSURANCE_FORM_VALIDATION_ERROR,
  INSURANCE_OPEN_ERROR_DIALOG,
  INSURANCE_CLOSE_ERROR_DIALOG,
  INSURANCE_CLICK_CLOSE_CTA_ERROR_DIALOG,
  INSURANCE_CLICK_CONTINUE_CTA_ERROR_DIALOG,
  OVERRIDE_INSURANCE_ERROR,
} from '../../core/analytics/events';
import { analyticsTrackFormErrors, analyticsTrackEvent } from '../../core/analytics';
import localizedStr, { EN_US, SupportedLocale } from '../../core/util/localizedStr';
import { capitalize } from '../../core/util/string';
import { getDays, getMonths } from '../SolvPatternLibrary/BirthDateInput/util';
import { dobYearValidator } from '../../core/util/rcForm/validators';
import { validateDob } from '../../core/util/form';
import { standardizeYear } from '../../core/util/date';
import AutosuggestTextField from '../SolvPatternLibrary/AutosuggestTextField';
import { stripNonNumeric } from '../../core/util/string';
import HelpfulHint from './components/HelpfulHint';
import { getFields } from './util/insuranceForm';
import { isEmptyArray } from '../../core/util/array';
import { getInsuranceTypes } from './util/insuranceTypes';
import { getMismatchedFields, isEmptyObject, safeGet } from '../../core/util/object';
import ErrorMessageDialog from '../SolvPatternLibrary/ErrorMessageDialog';
import { mappErrorCategoryToMessage } from './util/insuranceCoverageErrors';
import { insurerSuggestionFilter } from './util/insurers';
import { colors } from '../../constants/colors';
import { getCurrentPath } from '../../core/util/url';
import { OriginType } from '../../core/util/bookingFlowRoutingTypes';
import { getSkipButtonCopy } from './util/insuranceForm';
import { ADD_INSURANCE_ORIGIN_BOOKING_WIDGET } from '../../core/util/bookingFlowRouting';

const MOBILE_CONTAINER_MAX_WIDTH = '330px';
const BUTTON_ANIMATION_DELAY = 800;
const SHORT_WIDTH = 22;
const DAY_YEAR_OFFSET = 4;

const FormContainer = styled(Grid)`
  width: 90%;
  max-width: ${MOBILE_CONTAINER_MAX_WIDTH};
  margin: auto;

  ul {
    list-style: none;
    padding: 0;
  }
`;

const AddInsuranceButton = styled(Button)`
  width: 100%;
  -webkit-font-smoothing: antialiased;
`;

const ShortInputContainer = styled(Grid)`
  max-width: ${SHORT_WIDTH}%;
  flex-basis: 22%;
  margin: 5px 0;
`;

const NextButton = styled(Button)`
  display: block;
  margin: 10px auto 0;
  -webkit-font-smoothing: antialiased;
  text-transform: none;
`;

const DayInputContainer = styled(ShortInputContainer)`
  max-width: ${SHORT_WIDTH - DAY_YEAR_OFFSET}%;
`;

const YearInputContainer = styled(ShortInputContainer)`
  max-width: ${SHORT_WIDTH + DAY_YEAR_OFFSET}%;
`;

const MediumInputContainer = styled(Grid)`
  max-width: 48%;
  flex-basis: 48%;
  margin: 5px 0;
`;

const LargeInputContainer = styled(Grid)`
  margin: 5px 0;
`;

const Details = styled(Grid)`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.default};
  color: ${colors.squid};
  margin: 10px 8px -10px;
`;

const ButtonContainer = styled.div`
  margin-top: 20px;
`;

const SuggestionItem = styled.div`
  padding: 7px 16px;
  cursor: pointer;
  border-bottom: 1px solid ${colors.fatherJohnMisty};
`;

const HighlightedText = styled.span`
  color: ${(props) =>
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    props.sc.highlighted ? colors.crunchBerry : colors.squid};
`;

type Props = {
  form: formShape;
  location: Location;
  submitInsuranceInformation: (...args: any[]) => any;
  fetchInsurersList: (...args: any[]) => any;
  insurers: any[];
  initialValues?: any;
  isEditFlow?: boolean;
  insuranceCard?: any;
  passThrough?: string;
  currentUser?: any;
  insuranceCoverage?: any;
  addInsuranceFlow?: string;
  handleSkip?: (...args: any[]) => any;
  closeModal?: (...args: any[]) => any;
  origin: OriginType;
  showSnackbar?: (...args: any[]) => any;
  onSubmitSuccessCallback?: (...args: any[]) => any;
  locale?: SupportedLocale;
  isMobileFlow: boolean;
};

type State = any;

class InsuranceForm extends Component<Props, State> {
  static defaultProps = {
    initialValues: {},
    locale: EN_US,
  };

  state: State = {
    submitting: false,
    errors: {},
    buttonStatus: 'initial',
    submitButtonDisabled: true,
    errorDialogOpen: false,
  };

  componentDidMount = () => {
    const { insurers, fetchInsurersList, form } = this.props;
    form.validateFields(this.enableFormSubmissionIfNoErrors);
    if (isEmptyArray(insurers)) {
      fetchInsurersList();
    }
  };

  componentDidUpdate = (prevProps: any) => {
    if (this.didInsuranceCoverageCheckFinish(prevProps)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ submitting: false });

      const { insuranceCoverage } = this.props;
      if (this.didInsuranceCoverageCheckErrored(insuranceCoverage)) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ buttonStatus: 'error' }, this.openErrorDialog);
      } else {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ buttonStatus: 'success' }, this.goToNextPage);
      }
    }

    /* This exists because as soon as validate runs, it not longer respects
     * initialValues being passed in. This is understandable behavior, but
     * I need to override it so that when the insurance card data gets set,
     * you see the change reflected in the form. */
    const { initialValues, form } = this.props;
    const { initialValues: oldValues } = prevProps;
    const changedValues = getMismatchedFields(initialValues, oldValues);
    form.resetFields(changedValues);
    changedValues.forEach((value) => this.onBlur(value));
  };

  onFieldChange = (value: any, fieldName: any) => {
    const { form } = this.props;
    const { errors } = this.state;
    this.setState({ errors: { ...errors, [fieldName]: false } });
    form.setFieldsValue({ [fieldName]: value });

    form.validateFields(this.enableFormSubmissionIfNoErrors);
  };

  onBlur = (fieldName: any) => {
    const { form } = this.props;
    form.validateFields([fieldName], {}, (errors: any) => {
      this.enableFormSubmissionIfNoErrors(errors);
      if (isEmptyObject(errors)) {
        this.setState({ errors: { [fieldName]: false } });
      } else {
        this.setState({ errors: { [fieldName]: errors[fieldName] } });
      }
    });
  };

  onSubmit = (e: any) => {
    const { form } = this.props;

    e.preventDefault();
    this.setState({ submitting: true, buttonStatus: 'loading' });

    form.validateFields(this.onValidationDone);
  };

  onValidationDone = (fieldErrors: any, values: any) => {
    const {
      submitInsuranceInformation,
      location,
      insurers,
      initialValues: { cardIds = {} },
      currentUser,
      addInsuranceFlow,
    } = this.props;
    const dobErrors = validateDob(values.dobMonth, values.dobDay, values.dobYear);
    const formErrors = { ...fieldErrors, ...dobErrors };
    if (isEmptyObject(formErrors)) {
      submitInsuranceInformation(
        addInsuranceFlow,
        { ...values, cardFront: cardIds.front, cardBack: cardIds.back },
        location,
        currentUser,
        insurers
      );
      return;
    }

    this.setState({
      submitting: false,
      errors: formErrors,
      buttonStatus: 'initial',
    });
    analyticsTrackFormErrors(INSURANCE_FORM_VALIDATION_ERROR, formErrors);
  };

  getModalEventProperties = () => ({
    title: this.getCoverageErrorTitle(),
    body: this.getCoverageErrorDescription(),
    locationId: safeGet(this.props.location)('id'),
  });

  getCoverageErrorTitle = () => {
    const { insuranceCoverage, form, locale } = this.props;
    const insuranceTypeId = getFields(locale).insuranceType.id;
    if (insuranceTypeId) {
      const insuranceType = form.getFieldValue(insuranceTypeId);
      if (
        !isEmptyObject(insuranceCoverage.result) &&
        !isEmptyObject(insuranceCoverage.result.eligibility_error)
      ) {
        const errorContent = mappErrorCategoryToMessage(
          insuranceCoverage.result.eligibility_error.category,
          insuranceType
        );
        return errorContent.header;
      }
    }

    return "We weren't able to verify your information";
  };

  getCoverageErrorDescription = () => {
    const { insuranceCoverage } = this.props;
    if (
      !isEmptyObject(insuranceCoverage.result) &&
      !isEmptyObject(insuranceCoverage.result.eligibility_error)
    ) {
      const errorContent = mappErrorCategoryToMessage(
        insuranceCoverage.result.eligibility_error.category
      );
      return errorContent.body;
    }

    return 'You can try again or present your card at the clinic.';
  };

  getInsuranceButtonCopy = () => {
    const { isEditFlow, locale = EN_US } = this.props;
    let text = localizedStr[locale].ADD_INSURANCE;
    if (isEditFlow) {
      text = localizedStr[locale].UPDATE_INSURANCE;
    } else if (this.isUploadingInsuranceToAccount()) {
      text = localizedStr[locale].SAVE_INSURANCE;
    }

    return capitalize(text, { locale });
  };

  isUploadingInsuranceToAccount = () =>
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    getCurrentPath() && getCurrentPath().includes('/add-insurance/up');

  goToNextPage = () => {
    const { passThrough } = this.props;
    setTimeout(() => {
      // @ts-expect-error ts-migrate(2769) FIXME: Type 'undefined' is not assignable to type 'Locati... Remove this comment to see the full error message
      history.push(passThrough);
    }, BUTTON_ANIMATION_DELAY);
  };

  enableFormSubmissionIfNoErrors = (errors: any) =>
    isEmptyObject(errors)
      ? this.state.submitButtonDisabled && this.setState({ submitButtonDisabled: false })
      : this.state.submitButtonDisabled || this.setState({ submitButtonDisabled: true });

  openErrorDialog = () => {
    this.setState({
      errorDialogOpen: true,
    });
    analyticsTrackEvent(INSURANCE_OPEN_ERROR_DIALOG, this.getModalEventProperties());
  };

  closeErrorDialog = (closeFromCta = false) => {
    this.setState({
      errorDialogOpen: false,
    });

    const eventName = closeFromCta
      ? INSURANCE_CLICK_CLOSE_CTA_ERROR_DIALOG
      : INSURANCE_CLOSE_ERROR_DIALOG;
    analyticsTrackEvent(eventName, this.getModalEventProperties());
  };

  clickDialogRightCta = () => {
    const { passThrough } = this.props;
    analyticsTrackEvent(INSURANCE_CLICK_CONTINUE_CTA_ERROR_DIALOG, this.getModalEventProperties());
    // @ts-expect-error ts-migrate(2769) FIXME: Type 'undefined' is not assignable to type 'Locati... Remove this comment to see the full error message
    history.push(passThrough);
  };

  didInsuranceCoverageCheckErrored = (insuranceCoverage: any) => {
    // It started so simple, then reality set in and it turns out insurance sucks
    if (insuranceCoverage.result && !isEmptyObject(insuranceCoverage.result.eligibility_error)) {
      if (
        ['invalid', 'cant_reach_carrier'].includes(
          insuranceCoverage.result.eligibility_error.category
        )
      ) {
        analyticsTrackEvent(OVERRIDE_INSURANCE_ERROR, {
          category: insuranceCoverage.result.eligibility_error.category,
        });
        return false;
      }

      return true;
    }

    return !isEmpty(insuranceCoverage.error);
  };

  didInsuranceCoverageCheckFinish = (prevProps: any) =>
    prevProps.insuranceCoverage.submitting === true &&
    this.props.insuranceCoverage.submitting === false;

  validateDobFields = () => {
    const fields = getFields(this.props.locale);
    return this.props.form.validateFields(
      [fields.dobYear.id, fields.dobMonth.id, fields.dobDay.id],
      {},
      (fieldErrors: any, values: any) => {
        const dobErrors = validateDob(values.dobMonth, values.dobDay, values.dobYear);
        const formErrors = { ...fieldErrors, ...dobErrors };
        this.setState({ errors: formErrors });
      }
    );
  };

  isSubmitButtonDisabled = () => this.state.submitButtonDisabled;

  insurerSuggestionRenderer = (suggestion: any, properties: any) => {
    const { query } = properties;

    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);

    return (
      <SuggestionItem>
        {parts.map((part: any, index: any) => (
          // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type 'IntrinsicAtt... Remove this comment to see the full error message
          <HighlightedText key={index} sc={{ highlighted: part.highlight }}>
            {part.text}
          </HighlightedText>
        ))}
      </SuggestionItem>
    );
  };

  skipButtonRenderer = () => {
    const { location, origin, isEditFlow, locale = EN_US, handleSkip, isMobileFlow } = this.props;
    const { isInsuranceRequiredForBooking } = location;
    if (isInsuranceRequiredForBooking && origin === ADD_INSURANCE_ORIGIN_BOOKING_WIDGET) {
      return null;
    }

    const isInsuranceFormPage = true;
    let text = localizedStr[locale].CANCEL;
    if (!isEditFlow) {
      text =
        getSkipButtonCopy(
          origin,
          isInsuranceRequiredForBooking,
          isMobileFlow,
          isInsuranceFormPage,
          { locale }
        ) ?? text;
    }
    text = capitalize(text, { locale });

    return (
      <NextButton
        data-testid="insuranceFormSkipBtn"
        disableRipple
        onClick={handleSkip}
        variation={ButtonVariations.link}
      >
        {text}
      </NextButton>
    );
  };

  render = () => {
    const { form, insurers, initialValues, insuranceCard, locale = EN_US } = this.props;
    const insuranceTypeOptions = [
      {
        value: '',
        label: '',
        key: 'default',
      },
      ...getInsuranceTypes(locale),
    ];
    const { errors, buttonStatus, errorDialogOpen } = this.state;
    const fields = getFields(locale);
    return (
      <Grid item xs={12}>
        <form onSubmit={this.onSubmit}>
          <FormContainer container justify="space-between">
            <HelpfulHint insuranceCard={insuranceCard} />

            <LargeInputContainer item xs={12}>
              <AutosuggestTextField
                {...form.getFieldProps(fields.insuranceCarrier.id, {
                  rules: [{ required: true }],
                  initialValue: initialValues.insuranceCarrier || '',
                })}
                customSuggestionsFilter={insurerSuggestionFilter}
                data-testid="insurersAutosuggestInput"
                error={Boolean(errors?.insuranceCarrier)}
                fullWidth
                label={fields.insuranceCarrier.label}
                onBlur={() => this.onBlur(fields?.insuranceCarrier?.id)}
                onChange={(e: any, { newValue }: any) =>
                  this.onFieldChange(newValue, fields.insuranceCarrier.id)
                }
                renderSuggestion={this.insurerSuggestionRenderer}
                suggestions={insurers}
              />
            </LargeInputContainer>

            <MediumInputContainer item xs={6}>
              <TextField
                {...form.getFieldProps(fields.memberId.id, {
                  rules: [{ required: true }],
                  initialValue: initialValues.memberId || '',
                })}
                data-testid="memberIdInput"
                error={Boolean(errors?.memberId)}
                fullWidth
                label={fields.memberId.label}
                onBlur={() => {
                  const value = form.getFieldValue(fields.memberId.id);
                  const strippedValue =
                    typeof value === 'string' ? value.replace(/\s/g, '') : value;
                  this.onFieldChange(strippedValue, fields.memberId.id);
                  this.onBlur(fields.memberId.id);
                }}
                onChange={({ target: { value } }: any) =>
                  this.onFieldChange(value, fields.memberId.id)
                }
              />
            </MediumInputContainer>

            <MediumInputContainer item xs={6}>
              <SelectTextField
                {...form.getFieldProps(fields.insuranceType.id, {
                  rules: [{ required: true }],
                  initialValue: initialValues.insuranceType || '',
                })}
                data-testid="insuranceTypeInput"
                error={Boolean(errors.insuranceType)}
                fullWidth
                label={fields.insuranceType.label}
                onBlur={() => this.onBlur(fields.insuranceType.id)}
                onChange={({ target: { value } }: any) =>
                  this.onFieldChange(value, fields.insuranceType.id)
                }
                selectOptions={insuranceTypeOptions}
              />
            </MediumInputContainer>

            <Details item xs={12}>
              {capitalize(localizedStr[locale].CARDHOLDER_DETAILS, { locale })}
            </Details>

            <MediumInputContainer item xs={6}>
              <TextField
                {...form.getFieldProps(fields.firstName.id, {
                  rules: [{ required: true }],
                  initialValue: initialValues.firstName || '',
                })}
                autoComplete="given-name"
                data-testid="firstNameInput"
                error={Boolean(errors.firstName)}
                fullWidth
                label={fields.firstName.label}
                onBlur={() => this.onBlur(fields.firstName.id)}
                onChange={({ target: { value } }: any) =>
                  this.onFieldChange(value, fields.firstName.id)
                }
              />
            </MediumInputContainer>

            <MediumInputContainer item xs={6}>
              <TextField
                {...form.getFieldProps(fields.lastName.id, {
                  rules: [{ required: true }],
                  initialValue: initialValues.lastName || '',
                })}
                autoComplete="family-name"
                data-testid="lastNameInput"
                error={Boolean(errors.lastName)}
                fullWidth
                label={fields.lastName.label}
                onBlur={() => this.onBlur(fields.lastName.id)}
                onChange={({ target: { value } }: any) =>
                  this.onFieldChange(value, fields.lastName.id)
                }
              />
            </MediumInputContainer>

            <MediumInputContainer item xs={6}>
              <SelectTextField
                {...form.getFieldProps(fields.dobMonth.id, {
                  rules: [{ required: true }],
                  initialValue: initialValues.dobMonth || '',
                })}
                data-hj-suppress
                data-testid="dobMonthInput"
                error={Boolean(errors.dobMonth)}
                fullWidth
                label={fields.dobMonth.label}
                onBlur={this.validateDobFields}
                onChange={({ target: { value } }: any) =>
                  this.onFieldChange(value, fields.dobMonth.id)
                }
                selectOptions={getMonths(locale)}
              />
            </MediumInputContainer>

            <DayInputContainer item xs={3}>
              <SelectTextField
                {...form.getFieldProps(fields.dobDay.id, {
                  rules: [{ required: true }],
                  initialValue: initialValues.dobDay || '',
                })}
                data-hj-suppress
                data-testid="dobDayInput"
                error={Boolean(errors.dobDay)}
                fullWidth
                label={fields.dobDay.label}
                onBlur={this.validateDobFields}
                onChange={({ target: { value } }: any) =>
                  this.onFieldChange(value, fields.dobDay.id)
                }
                selectOptions={getDays()}
              />
            </DayInputContainer>

            <YearInputContainer item xs={3}>
              <TextField
                {...form.getFieldProps(fields.dobYear.id, {
                  rules: [
                    {
                      required: true,
                      validator: dobYearValidator,
                    },
                  ],
                  initialValue: initialValues.dobYear || '',
                })}
                data-testid="dobYearInput"
                error={Boolean(errors?.dobYear)}
                fullWidth
                inputProps={{
                  maxLength: 4,
                }}
                label={fields.dobYear.label}
                onBlur={({ target: { value } }: any) => {
                  this.onFieldChange(String(standardizeYear(value)), fields.dobYear.id);
                  this.validateDobFields();
                }} // jscs:disable
                onChange={({ target: { value } }: any) =>
                  this.onFieldChange(stripNonNumeric(value), fields.dobYear.id)
                }
              />
            </YearInputContainer>

            <LargeInputContainer item xs={12}>
              <ButtonContainer>
                <AddInsuranceButton
                  animationEnabled
                  data-testid="addInsuranceSubmitBtn"
                  disabled={this.isSubmitButtonDisabled()}
                  status={buttonStatus}
                  type="submit"
                  variation={ButtonVariations.pinkPrimary}
                >
                  {this.getInsuranceButtonCopy()}
                </AddInsuranceButton>
                {this.skipButtonRenderer()}
              </ButtonContainer>
            </LargeInputContainer>
          </FormContainer>
        </form>

        <ErrorMessageDialog
          description={this.getCoverageErrorDescription()}
          isOpen={errorDialogOpen}
          onClickCtaLeft={() => this.closeErrorDialog(true)}
          onClickCtaRight={this.clickDialogRightCta}
          onClose={this.closeErrorDialog}
          title={this.getCoverageErrorTitle()}
        />
      </Grid>
    );
  };
}

export default createForm()(InsuranceForm);
